<template lang="html">
	<router-link :to="{ name: 'Article', params: { id: article.id }}" class="article advise">
		<div class="body-article row">
			<div class="ctn-img small">
				<img :src="article.image" alt="">
			</div>
			<div class="ctn-text column">
				<div class="title">
					{{ article.title}}
				</div>
				<div class="ctn-tags row">
					<div class="tag" v-for="(tag, keyt) in article.news_tags" v-bind:key="keyt">
						{{ resolveTag(tag) }}
					</div>
				</div>
				<div class="desc" v-html="strip(article.body)"></div>
			</div>
		</div>
	</router-link>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	name: 'advise',
	props: ['article'],
	mounted () {
		console.log(this.article)
	},
	methods: {
		strip (s) { return s.replace(/<\/?[^>]+(>|$)/g, '').substring(0, 120) + '...' },
		resolveTag (tag) {
			if (typeof tag === 'number') {
				return this.tags.filter((t) => (t.wordpress_tag_id === tag))[0].wordpress_tag_name
			} else {
				return tag.tags.wordpress_tag_name
			}
		}
	},
	computed: {
		...mapGetters({
			tags: 'tags'
		})
	}
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/common/components/advise.vue